var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"id":"selected","options":_vm.options,"required":""},on:{"focus":function($event){return _vm.clearErrorField('selected')}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }